module.exports = __webpack_public_path__ + "static/media/problem-definition-large.1fe264cd.png";